<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions, mapGetters } from "vuex";
import Pagination from "../../../components/pagination.vue";
import formatter from "../../../mixins/formatter";
export default {
    page: {
        title: "Seasons",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
        Pagination
    },
    mixins: [
        formatter
    ],
    data() {
        return {
            title: "Seasons",
            totalWingband: 0,
            data: {
                list: [],
                links: [],
                current_page: 1,
                per_page: 1,
                last_page: 1,
            },
            statistics_data: {
                early_bird: "",
                local: "",
                national: "",
                late_born: "",
                genesis: "",
            },
            filter: {
                year: "",
                search: "",
                season: 1,
                limit: 10,
            },
        };
    },
    created() {
        const total = this.$route.query.totalWingband;
        this.totalWingband = total ? parseInt(total, 10) : 0;
    },
    computed: {
        ...mapGetters("auth", ["profile"]),
        ...mapGetters("seasonColors", { seasonColors: "colors" }),
    },
    methods: {
        ...mapActions("wingband", {
            getWList: "getList",
        }),
        ...mapActions("seasons", {
            getList: "getList",
            getStatistics: "getStatistics",
        }),
        filterList() {
            this.initList(1);
            this.initStatistics(1);
        },
        resetFilter() {
            this.filter.year = "";
            this.filter.search = "";
            this.filter.season = 1;
            this.filter.limit = 10;
            this.initList(1);
            this.initStatistics();
        },
        async initList(p) {
            var pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
            };
            if (this.filter.year) {
                pl["wingband_year"] = this.filter.year;
            }
            if (this.filter.search) {
                pl["search"] = this.filter.search;
            }
            if (this.filter.season) {
                pl["season"] = this.filter.season;
            }
            this.loading = true;
            const data = await this.getWList(pl);
            this.loading = false;
            this.data.list = data.data;
            this.data.links = data.links;
            this.data.current_page = data.current_page;
            this.data.per_page = data.per_page;
            this.data.last_page = data.last_page;

            if (data.data == null || data.data == "") {
                this.data.list = []
            }
        },
        async initStatistics() {
            this.loading = true;
            var pl = {
            }
            if (this.filter.year) {
                pl["year"] = this.filter.year;
            }
            const data = await this.getStatistics(pl);
            this.loading = false;
            this.statistics_data.early_bird = data.data[0].entry;
            this.statistics_data.local = data.data[1].entry;
            this.statistics_data.national = data.data[2].entry;
            this.statistics_data.late_born = data.data[3].entry;
            this.statistics_data.genesis = data.data[4] ? data.data[4].entry : 0;
        },
    },
    mounted() {
        this.initList(1);
        this.initStatistics();
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items">
            <button class="btn btn-info text-white" @click="$refreshPage()"><i class='bx bx-refresh'></i> Refresh</button>
        </PageHeader>
        <div class="row">
            <div class="col-lg-12">
                <div class="card mb-2 p-2">
                    <div class="grid-5">
                        <div class="w-100 text-center rounded" :style="{ backgroundColor: seasonColors.early_bird || '#6F42C1' }">
                            <div class="p-2">
                                <h1 class="text-white">{{ numToString(statistics_data.early_bird) }}</h1>
                                <h5 class="text-white">Early Bird</h5>
                            </div>
                        </div>
                        <div class="w-100 text-center rounded" :style="{ backgroundColor: seasonColors.local || '#28A745' }">
                            <div class="p-2">
                                <h1 class="text-white">{{ numToString(statistics_data.local) }}</h1>
                                <h5 class="text-white">Local</h5>
                            </div>
                        </div>
                        <div class="w-100 text-center rounded" :style="{ backgroundColor: seasonColors.national || '#FFC107' }">
                            <div class="p-2">
                                <h1 class="text-white">{{ numToString(statistics_data.national) }}</h1>
                                <h5 class="text-white">National</h5>
                            </div>
                        </div>
                        <div class="w-100 text-center rounded" :style="{ backgroundColor: seasonColors.late_born || '#ADB5BD' }">
                            <div class="p-2">
                                <h1 class="text-white">{{ numToString(statistics_data.late_born) }}</h1>
                                <h5 class="text-white">Late Born</h5>
                            </div>
                        </div>
                        <div class="w-100 text-center rounded" :style="{ backgroundColor: seasonColors.genesis || '#0DCAF0' }">
                            <div class="p-2">
                                <h1 class="text-white">{{ numToString(statistics_data.genesis) }}</h1>
                                <h5 class="text-white">Genesis</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="card mb-2 p-3">
                    <div class="row g-2">
                        <div class="col-12 col-lg-10">
                            <div class="grid-2">
                                <div class="disflex custom-border p-1">
                                    <label class="filter-label">Banding Year</label>
                                    <input type="text" class="form-control" v-model="filter.year">
                                </div>
                                <div class="disflex custom-border p-1">
                                    <label class="filter-label">Limit:</label>
                                    <select class="form-control w-25" v-model="filter.limit" @change="filterList()">
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="200">200</option>
                                        <option value="500">500</option>
                                        <option value="1000">1000</option>
                                        <option value="5000">5000</option>
                                    </select>
                                </div>
                                <div class="disflex custom-border p-1">
                                    <label class="filter-label">Search</label>
                                    <input type="text" class="form-control" v-model="filter.search">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-2">
                            <div class="d-flex flex-row flex-lg-column justify-content-start justify-content-lg-end align-items-stretch h-100 gap-2">
                                <button class="btn btn-success py-2 px-4" @click="filterList()">Apply Filter</button>
                                <button class="btn btn-secondary py-2 px-4" @click="resetFilter()">Reset</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="card mb-2 p-0 pt-2">
                    <div class="season d-flex mt-1 ms-1 flex-wrap gap-1 p-2">
                        <h6 @click="filter.season = 1, filterList()" class="season-tab cursor-pointer"
                            :class="filter.season == 1 ? 'season-tab--active' : 'season-tab--inactive'"
                            :style="filter.season == 1 ? { backgroundColor: seasonColors.early_bird || '#6F42C1', color: '#fff' } : {}">
                            Early Bird</h6>
                        <h6 @click="filter.season = 2, filterList()" class="season-tab cursor-pointer"
                            :class="filter.season == 2 ? 'season-tab--active' : 'season-tab--inactive'"
                            :style="filter.season == 2 ? { backgroundColor: seasonColors.local || '#28A745', color: '#fff' } : {}">
                            Local</h6>
                        <h6 @click="filter.season = 3, filterList()" class="season-tab cursor-pointer"
                            :class="filter.season == 3 ? 'season-tab--active' : 'season-tab--inactive'"
                            :style="filter.season == 3 ? { backgroundColor: seasonColors.national || '#FFC107', color: '#fff' } : {}">
                            National</h6>
                        <h6 @click="filter.season = 4, filterList()" class="season-tab cursor-pointer"
                            :class="filter.season == 4 ? 'season-tab--active' : 'season-tab--inactive'"
                            :style="filter.season == 4 ? { backgroundColor: seasonColors.late_born || '#ADB5BD', color: '#fff' } : {}">
                            Late Born</h6>
                        <h6 @click="filter.season = 5, filterList()" class="season-tab cursor-pointer"
                            :class="filter.season == 5 ? 'season-tab--active' : 'season-tab--inactive'"
                            :style="filter.season == 5 ? { backgroundColor: seasonColors.genesis || '#0DCAF0', color: '#fff' } : {}">
                            Genesis</h6>
                    </div>
                    <div class="pt-3 custom-overflow">
                        <table class="mb-0 table">
                            <thead>
                                <tr class="bg-light">
                                    <th>Id</th>
                                    <th>Stag Registry No.</th>
                                    <th>Name of Breeders</th>
                                    <th>Farm Name</th>
                                    <th>Farm Address</th>
                                    <th>Province</th>
                                    <th>Chapter</th>
                                    <th>Contact No.</th>
                                    <th>Wingband No.</th>
                                    <th>Feather Color</th>
                                    <th>Leg Color</th>
                                    <th>Comb Shape</th>
                                    <th>Nose Markings</th>
                                    <th>Feet Markings</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row, index in this.data.list" :key="index">
                                    <td>
                                        {{ index + 1 }}
                                    </td>
                                    <td>
                                        {{ row.stag_registry }}
                                    </td>
                                    <td>
                                        {{ row.breeder_name }}
                                    </td>
                                    <td>
                                        {{ row.farm_name }}
                                    </td>
                                    <td>
                                        {{ row.farm_address }}
                                    </td>
                                    <td>
                                        {{ row.province }}
                                    </td>
                                    <td>
                                        {{ row.chapter }}
                                    </td>
                                    <td>
                                        {{ row.contact_number }}
                                    </td>
                                    <td>
                                        {{ row.wingband_number }}
                                    </td>
                                    <td>
                                        {{ row.feather_color }}
                                    </td>
                                    <td>
                                        {{ row.leg_color }}
                                    </td>
                                    <td>
                                        {{ row.comb_shape }}
                                    </td>
                                    <td>
                                        {{ row.nose_markings }}
                                    </td>
                                    <td>
                                        {{ row.feet_markings }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="no-data disflex" v-if="this.data.list == null || this.data.list == ''">No wingbands
                            found...
                        </div>
                    </div>
                    <Pagination :data="data" @emitPage="initList" class="me-2" />
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
th,
td {
    width: 75px !important;
    text-align: center !important;
}

.table> :not(caption)>*>* {
    text-align: center !important;
    padding: .5rem .1rem !important;
}

th {
    text-transform: uppercase;
}

.grid-5 {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
}

.season-card-violet  { background-color: #6f42c1; }
.season-card-green   { background-color: #34c38f; }
.season-card-yellow  { background-color: #f1b44c; }
.season-card-silver  { background-color: #adb5bd; }
.season-card-skyblue { background-color: #0dcaf0; }

.season-tab {
    padding: 6px 16px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 13px;
    margin: 0;
    transition: all 0.15s;
    user-select: none;
}

.season-tab--inactive {
    background-color: #f1f3f4;
    color: #555;
}

.season-tab--inactive:hover {
    background-color: #e2e6ea;
}

.season-tab--active {
    color: #fff;
    box-shadow: 0 2px 6px rgba(0,0,0,0.2);
}

.season-tab--early-bird  { background-color: #6f42c1; }
.season-tab--local       { background-color: #34c38f; }
.season-tab--national    { background-color: #f1b44c; color: #333; }
.season-tab--lateborn    { background-color: #adb5bd; color: #333; }
.season-tab--genesis     { background-color: #0dcaf0; }
</style>